
export default function DashBoard() {

    return (
        <main className='mx-3 mt-16 sm:ml-[300px] sm:mt-3'>
            <h1>Dashboard still under development</h1>
        </main>
    )
}